export default "__VITE_ASSET__e976b4a0__"